export default __webpack_public_path__ + "static/media/email.88781baf.svg";